// extracted by mini-css-extract-plugin
module.exports = {"input":"Individuals_input__1QuJS","checkboxWarn":"Individuals_checkboxWarn__3KxGx"};